export class MediaTypes {
    id: number;
    group_id: number;
    location_id: number;
    media_type_name: string;
    media_type_field_type: string;
    export: boolean;
    order: number;
    max: number;
    created_at: string;
    updated_at: string;
}

// Names containing '.' cannot be bound directly as a DevExtreme dataField
// (dots are treated as nested object paths), so those columns use a
// sanitised dataField instead. Dot-free names keep their name-based
// dataField so saved grid state is not reset.
export function mediaTypeDataField(mediaType: MediaTypes): string {
    return mediaType.media_type_name.includes('.') ? `mt_${mediaType.id}` : mediaType.media_type_name;
}

export function findMediaTypeForKey(mediaTypes: MediaTypes[], key: string): MediaTypes | undefined {
    return mediaTypes.find(x => mediaTypeDataField(x) === key);
}
